<template>
  <div>
    <div v-if="UIController.error.error404" class="error-container">
      <div class="card-base">
        <div class="card-base__header">
          <div class="avatar">
            <img :src="require('@/assets/SWLOGO.png')" class="card__img" />
          </div>
          <h4 style="text-align:center;">Driving Innovation and Growth Unlimited</h4>
          <p class="description">
            The Professional Services Company that
            Builds your App and Scales your Team
          </p>
        </div>
        <div class="card__body">
          <div class="card-upper-section">
            <div class="info__pill phone">
              <div class="info__logo">
                <img :src="require('@/assets/web_black.svg')" class="info__logo-img" />
              </div>
              <div class="info__text">
                <a href="https://digu.one" class="base-link" target="_blank">
                  <span>Website</span><i class="chevron-right">></i>
                </a>
              </div>
            </div>
            <div class="info__pill phone">
              <div class="info__logo">
                <img :src="require('@/assets/solution_black.svg')" class="info__logo-img" />
              </div>
              <div class="info__text">
                <a href="https://digu.one/design-my-app" class="base-link" target="_blank">
                  <span>Our Solutions</span><i class="chevron-right">></i>
                </a>
              </div>
            </div>
            <div class="info__pill phone with-border">
              <div class="info__logo">
                <img :src="require('@/assets/blog_black.svg')" class="info__logo-img" />
              </div>
              <div class="info__text">
                <a href="https://digu.one/blogs-and-insights" class="base-link" target="_blank">
                  <span>Blogs and Insights</span><i class="chevron-right">></i>
                </a>
              </div>
            </div>
          </div>
          <div class="card-lower-section">
            <div class="info__pill phone with-border-d">
              <div class="info__logo">
                <img :src="require('@/assets/person_black.svg')" class="info__logo-img" />
              </div>
              <div class="info__text">
                <a href="https://digu.one/talents-on-demand" class="base-link" target="_blank">
                  <span>Join Our Talent Pool</span><i class="chevron-right">></i>
                </a>
              </div>
            </div>
            <div class="info__pill phone">
              <div class="info__logo">
                <img :src="require('@/assets/calendar.svg')" class="info__logo-img" />
              </div>
              <div class="info__text">
                <a href="https://digu.one/events" class="base-link" target="_blank">
                  <span>Upcoming Events</span><i class="chevron-right">></i>
                </a>
              </div>
            </div>
            <div class="info__pill phone">
              <div class="info__logo">
                <img :src="require('@/assets/certificate-solid.svg')" class="info__logo-img" />
              </div>
              <div class="info__text">
                <a href="https://digu.one/trainings-and-certifications" class="base-link" target="_blank">
                  <span>Training and Certifications</span><i class="chevron-right">></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="card__footer">
          <div class="social__container">
            <a href="https://www.linkedin.com/company/digu-official/" class="social__link linkedin" target="_blank">
              <img :src="require('@/assets/linkedin-in_black.svg')" alt="" class="social__image" />
            </a>
            <a href="https://www.instagram.com/digu.official/" class="social__link instagram" target="_blank">
              <img :src="require('@/assets/instagram_black.svg')" alt="" class="social__image" />
            </a>
            <a href="https://www.facebook.com/digu.official/" class="social__link facebook" target="_blank">
              <img :src="require('@/assets/facebook-f_black.svg')" alt="" class="social__image" />
            </a>
            <a href="https://x.com/digu_official" class="social__link x" target="_blank">
              <img :src="require('@/assets/x-twitter_black.svg')" alt="" class="social__image" />
            </a>
            <a href="https://www.youtube.com/@digu_official" class="social__link youtube" target="_blank">
              <img :src="require('@/assets/youtube_black.svg')" alt="" class="social__image" />
            </a>
            <a href="https://www.tiktok.com/@smartworkstechnology" class="social__link tiktok" target="_blank">
              <img :src="require('@/assets/tiktok_black.svg')" alt="" class="social__image" />
            </a>
          </div>
          <p class="copyright text-white">{{ getCurrentYear }} | DIGU</p>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="main-card-old" v-if="UIController.loader.detailsLoaded">
        <div class="card-header-old">
          <img :src="require('@/assets/SWLOGO.png')" class="card-logo-old" />
          <div style="padding-top: 1em;" class="header-details-old">
            <h2 class="card-title-old">
              <span style="margin-right: 0.5rem">{{ details.firstName || '' }}</span><strong>{{ details.lastName || '' }}</strong>
            </h2>
            <span class="card-sub-title-old">{{ details.designation || '' }}</span>
          </div>
          <img v-if="details.photoLink" :src="`${details.photoLink_}`" alt="Image" class="card-image-old" />
        </div>

        <div class="card-body-old">
          <div class="info-pill-old">
            <div class="info-logo-old">
              <img :src="require('@/assets/phone-solid.svg')" class="info-logo-img-old" />
            </div>
            <div class="info-text-old">
              <a :href="`tel:${details.phone}`" class="info-content-old link">{{ details.phone }}</a>
            </div>
          </div>
          <div class="info-pill-old">
            <div class="info-logo-old">
              <img :src="require('@/assets/at-solid.svg')" class="info-logo-img-old" />
            </div>
            <div class="info-text-old">
              <a :href="`mailto:${details.email}`" class="info-content-old link"><span class="mail-id">{{ details.firstName }}</span>.<span class="mail-id">{{ details.lastName }}</span></a>
            </div>
          </div>
          <div class="info-pill-old">
            <div class="info-logo-old">
              <img :src="require('@/assets/location-dot-solid.svg')" class="info-logo-img-old" />
            </div>
            <div class="info-text-old">
              <a target="_blank" :href="`https://google.com/maps/place/${details.location}`" class="info-content-old link">{{ details.location }}</a>
            </div>
          </div>
        </div>

        <div class="card-footer-old">
          <div class="social-container-old">
            <a href="https://digu.one" class="social-link-old website" target="_blank">
              <img :src="require('@/assets/globe-solid.svg')" alt="" class="info-logo-img-old" />
            </a>
            <a href="https://www.linkedin.com/company/digu-official" class="social-link-old linkedin" target="_blank">
              <img :src="require('@/assets/linkedin-in.svg')" alt="" class="social-image-old" />
            </a>
            <a href="https://www.instagram.com/digu.official/" class="social-link-old instagram" target="_blank">
              <img :src="require('@/assets/instagram.svg')" alt="" class="social-image-old" />
            </a>
            <a href="https://www.facebook.com/digu.official/" class="social-link-old facebook" target="_blank">
              <img :src="require('@/assets/facebook-f.svg')" alt="" class="social-image-old" />
            </a>
            <a href="https://x.com/digu_official" class="social-link-old x" target="_blank">
              <img :src="require('@/assets/x-twitter.svg')" alt="" class="social-image-old" />
            </a>
            <a href="https://www.youtube.com/@digu_official" class="social-link-old youtube" target="_blank">
              <img :src="require('@/assets/youtube.svg')" alt="" class="social-image-old" />
            </a>
          </div>
          <a class="vcard-button" :href="details.vcardLink_">Add to Contact</a>
          <p class="copyright">{{ getCurrentYear }} | DIGU</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contactService from './services/contactService';
export default {
  data: () => ({
    details: new Object(),
    UIController: {
      loader: {
        detailsLoaded: false,
      },
      error: {
        error404: false,
      },
    },
  }),
  beforeCreate() {
    document.title = 'DIGU';
  },
  async created() {
    if (!location.pathname === undefined) {
      this.UIController.error.error404 = true;
    }

    const slug = location.pathname;
    this.details = await contactService
      .fetchContact(slug)
      .then((response) => {
        if (!response) {
          this.UIController.error.error404 = true;
        }
        return response;
      })
      .catch((error) => {
        console.error(error);
        this.UIController.error.error404 = true;
      });

    if (this.details) {
      if (this.details.photoLink) {
        this.details.photoLink_ = `${process.env.VUE_APP_CDN_LINK}/${this.details.photoLink}`;
      }
      this.details.vcardLink_ = `${process.env.VUE_APP_CDN_LINK}/${this.details.vcardLink}`;
      document.title = `${this.details.firstName} ${this.details.lastName} | DIGU`;
    }
    this.UIController.loader.detailsLoaded = true;
  },
  computed: {
    getCurrentYear: () => {
      return new Date().getFullYear();
    },
  },
};
</script>
<style scoped>
/* ---------- COMMON STYLES FOR ERROR CARD (v-if) ---------- */
.main-card,
.card-base {
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  max-width: 375px;
  margin-top: 2rem;
  border-radius: 10px;
  color: #f5f5f5;
  overflow: hidden;
}

.card-base {
  background: url('@/assets/baseBG.webp');
  background-size: cover;
  font-family: Manrope, sans-serif;
  border-radius: 1.75rem;
}

.card-base__header {
  padding: 1rem;
  text-align: center;
}

.card-base__header .card__img {
  width: 9rem;
  padding: 0.5rem;
  margin: 0 auto;
  margin-top: 2rem;
}

.card-base__header h4 {
  text-align: center;
  margin-bottom: 0.5rem;
  font-family: Manrope, sans-serif;
  color: #fff;
}

.card-base__header .description {
  text-align: center;
  font-size: 0.85rem;
  margin-top: 0px;
  color: #fff;
}

.card__body {
  display: flex;
  flex-direction: column;
  width: 90%;
  background-color: #00519180;
  margin-bottom: 1.5rem;
  border-radius: 0.8rem;
}

.card-upper-section {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  width: 90%;
  margin-left: 15px;
}

.card-lower-section {
  margin-top: 1rem;
  width: 90%;
  margin-left: 15px;

}

.info__pill {
  display: flex;
  align-items: center;
  padding: 0.8rem;
}

.info__pill.with-border {
  margin-bottom: 1rem;
}

.info__pill.with-border-d {
  margin-top: 1rem;
}

.info__logo {
  display: flex;
  align-items: center;
  margin-right: 1rem;
}

.info__logo-img {
  width: 18px;
  aspect-ratio: 1;
  filter: brightness(0) invert(1);
}

.info__text {
  flex-grow: 1;
  text-align: left;
}

.info__text a {
  text-decoration: none;
  color: #fff;
  font-size: 1rem;
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 1rem;
}

.info__text a .chevron-right {
  color: #fff;
  font-size: 1.2rem;
  margin-left: 0.5rem;
}

.info__text a:hover {
  color: #ffd700;
}

.card__footer {
  width: 90%;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.social__container {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.social__link {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: rgba(255, 255, 255, 0.2); */
  outline: 1px solid rgba(255, 255, 255, 0.3);
  transition: background-color 0.3s;
}

.social__link:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
.facebook:hover{
  background: #1877f2;
}
.tiktok:hover{
  background: #000000;
}
.instagram:hover{
  background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045);
}
.x:hover{
  background: #000000;
}
.youtube:hover{
  background-color: red;
}
.linkedin:hover{
  background-color: #0a66c2;
}
.social__image {
  width: 20px;
  aspect-ratio: 1;
  filter: brightness(0) invert(1);
}

.text-white {
  color: #fff !important;
}

.copyright {
  text-align: center;
  font-size: 0.85rem;
  color: #706c6c;
  font-family: 'Manrope', sans-serif;
}

/* ---------- OLD DESIGN STYLES FOR CONTACT CARD (v-else) ---------- */
.main-card-old {
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f0f0;
  max-width: 375px;
  border-radius: 10px;
  color:#fff;
  overflow: hidden;
  margin-top: 2rem;
}

.card-header-old {
  background: url('assets/vector.svg');
  background-position-y: -1rem;
  padding: 1rem;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 250px;
}

.card-logo-old {
  width: 6rem;
  align-self: flex-end;
  margin-right: 1rem;
}

.card-title-old {
  font-family: 'Manrope';
  font-size: 1.75rem;
  display: flex;
  width: 100%;
  margin-left: 2rem;
  margin-top: 0px;
  margin-bottom: 1rem;
}

.card-title-old strong {
  font-weight: 700;
}

.card-title-old span {
  font-weight: 300;
}

.card-sub-title-old {
  font-family: 'Manrope';
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  width: 60%;
  margin-top: -1rem;
  margin-left: 2rem;
  color: #fff;
}

.card-image-old {
  width: 128px;
  aspect-ratio: 1;
  border-radius: 20em;
  align-self: end;
  margin-right: 1rem;
}

.card-body-old {
  display: grid;
  grid-template-columns: 1fr;
  width: 90%;
  margin: 1rem;
}

.info-pill-old {
  display: grid;
  grid-template-columns: 1fr 4fr;
  column-gap: 1rem;
  padding: 0.8rem;
  border-radius: 0.8rem;
  background-color: #fff;
  margin-bottom: 0.5rem;
}

.info-logo-old {
  display: grid;
  align-content: center;
}

.info-logo-img-old {
  width: 18px;
  aspect-ratio: 1;
}

.info-text-old {
  display: grid;
  align-content: center;
}

.info-content-old {
  font-family: 'Manrope', sans-serif;
  text-decoration: none;
  color: #6d6371;
  font-size: 1rem;
  line-height: 1rem;
  font-weight: 600;
}

.info-content-old.link:hover {
  text-decoration: underline;
}

.card-footer-old {
  width: 90%;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.social-container-old {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  justify-items: center;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.5rem;
}

.social-link-old {
  width: 36px;
  height: 36px;
  border-radius: 20px;
  display: grid;
  align-items: center;
  justify-items: center;
}

.social-link-old.linkedin {
  background-color: #0a66c2;
}

.social-link-old.website {
  background-color: #2ea3f2;
}

.social-link-old.instagram {
  background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045);
}

.social-link-old.facebook {
  background: #1877f2;
}

.social-link-old.x {
  background: #000000;
}

.social-link-old.youtube {
  background: #ff0000;
}

.social-image-old {
  width: 20px;
  aspect-ratio: 1;
}

.vcard-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2ea3f2;
  text-decoration: none;
  padding: 15px;
  font-family: 'Manrope';
  margin-top: 1rem;
  margin-bottom: 1rem;
  color: #f0f0f0;
  border-radius: 100px;
}

.mail-id {
  text-transform: lowercase;
}

.error-container {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
